var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditRules(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.91 59.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#134fc8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.91,8.2A8.2,8.2,0,0,0,65.72,0H22.1a7.93,7.93,0,0,0-7.92,7.92V42.65H0v8.92a8.21,8.21,0,0,0,8.2,8.19H52.1A7.93,7.93,0,0,0,60,51.84V17.11H73.91ZM39.53,57.26H8.2a5.7,5.7,0,0,1-5.7-5.69V45.15H43.56v6.42a8.14,8.14,0,0,0,2.31,5.69Zm18-5.42a5.42,5.42,0,0,1-5.42,5.42h-.34a5.7,5.7,0,0,1-5.7-5.69V42.65H16.68V7.92A5.43,5.43,0,0,1,22.1,2.5H59.84a8.17,8.17,0,0,0-2.32,5.7V51.84ZM71.41,14.61H60V8.2a5.7,5.7,0,1,1,11.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.38,11.87H37.84a1.25,1.25,0,0,0,0,2.5H49.38a1.25,1.25,0,0,0,0-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.38,22.14H37.84a1.25,1.25,0,0,0,0,2.5H49.38a1.25,1.25,0,1,0,0-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.38,32.4H37.84a1.25,1.25,0,0,0,0,2.5H49.38a1.25,1.25,0,0,0,0-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,9.93l-3.2,3.21-1.58-1.58a1.25,1.25,0,0,0-1.77,1.76l3.35,3.35,5-5A1.25,1.25,0,0,0,31,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,20.2l-3.2,3.21-1.58-1.58a1.25,1.25,0,0,0-1.77,1.77l3.35,3.34,5-5a1.25,1.25,0,0,0,0-1.77A1.27,1.27,0,0,0,31,20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,30.46l-3.2,3.21-1.58-1.59a1.27,1.27,0,0,0-1.77,0,1.25,1.25,0,0,0,0,1.77l3.35,3.35,5-5A1.25,1.25,0,0,0,31,30.46Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditRules);
export default __webpack_public_path__ + "static/media/credit-rules.e03d123b7b0d306e6348debbb9b9f259.svg";
export { ForwardRef as ReactComponent };